// extracted by mini-css-extract-plugin
module.exports = {"list":"linkList_list__NOznH","item":"linkList_item__CZKnm","link":"linkList_link__KtFzB"};